module.exports = __webpack_public_path__ + "img/triangle-30.e9de7e1b.gif";